import React from 'react'
import { useLocalization } from '@/hooks/localization'
import { BsrsGrid, Column, commandColumnProps, createLookupFilterCell, LookupCell } from '@/components/BsrsGrid'
import Resx from '@/components/Resx'
import { Main, MainTop, MainTopTitle, MainTopLeft, MainBody } from '@/components/Layout'
import context from '@/context'
import { CreateChangeItem } from '@/components/changeRequests/createChangeItem'
import cached from '@/internal-app/cached'
import NameColumn from '@/components/BsrsGrid/BsrsGrid.NameColumn'

const BankList = React.memo(() => {
  const { localize, locale } = useLocalization()

  return (
    <Main>
      <MainTop>
        <MainTopTitle>
          <Resx name='Institutions.BanksTitle' />
        </MainTopTitle>
        <MainTopLeft>
          <CreateChangeItem buttonText='Institutions.CreateNewBank'
            scope='Banks'
            additionalPermission='CanCreateBanks' />
        </MainTopLeft>
      </MainTop>
      <MainBody>
        <BsrsGrid persistenceId={'banks'} dataSource={context.api.bankService.getBanks}>
          {NameColumn({ locale, title: localize('Common.Name'), editable: false })}
          <Column field='code' title={localize('Common.Code')} />
          <Column field='bankType' title={localize('Common.Type')} cell={LookupCell} width='120px'
            filterCell={createLookupFilterCell(cached.getBankTypes)} />
          <Column field='status' title={localize('Common.Status')} cell={LookupCell} width='120px'
            filterCell={createLookupFilterCell(cached.getBankStates)} />
          <Column {...commandColumnProps({ detailUrl: x => `/banks/${x.id}` })} />
        </BsrsGrid>
      </MainBody>
    </Main>
  )
})

export {
  BankList
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/banks/list.js